import styled from "@emotion/styled";

export const OrderDetailsSearchLineItemsWrapper = styled.div(({ theme }) => ({
	display: "flex",
	alignItems: "center",
	justifyContent: "space-between",
	"> span": {
		...theme.project.typography.subtitle.subtitle1,
		color: theme.project.colors.fontColors.main,
		fontSize: "12px"
	},
	[theme.breakpoints.down("sm")]: {
		flexDirection: "column",
		gap: "8px",
		alignItems: "flex-start",
		div: {
			width: "100%"
		}
	}
}));
